import ReportList from '@components/common/ReportList';
import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { useFetchTeamMembers, useSingleInterview } from '@hooks/getQueries';
import { useUserPermission } from '@hooks/userPermission';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

export default function InterviewReport() {
  const { id } = useParams();
  const { data: interview } = useSingleInterview(id);
  const { data: teamMembers } = useFetchTeamMembers({
    studyId: id,
    studyUrlType: 'qualitative-studies',
  });
  const { canEdit } = useUserPermission({
    entity: interview,
    teamMembers: teamMembers,
  });

  return (
    <PageContainer title={'Interview | Custom Reports'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
          <ReportList studyType="interview" canManageReport={canEdit} />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
